/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementProjectFields {
    getFixupPrototypeFunction() { return JiraServiceManagementProjectFields.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementProjectFields>): JiraServiceManagementProjectFields {
        let obj = Object.assign(new JiraServiceManagementProjectFields(), model);
        JiraServiceManagementProjectFields.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementProjectFields>): JiraServiceManagementProjectFields {
        if (!model) return null;
        return JiraServiceManagementProjectFields.newInstance(<JiraServiceManagementProjectFields> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementProjectFields) {
        if (!obj) return;

        models.JiraServiceManagementProjectFields.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementProjectFields): boolean {
        Object.setPrototypeOf(obj, JiraServiceManagementProjectFields.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Key associated with the field
     */
    key: string;

    /**
     * Name of the field
     */
    name: string;

}
